import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about7">

      {/* ================= HERO ================= */}
      <section className="ab7-hero">
        <h1>About PULSE</h1>
        <p>
          Built for discipline. Driven by performance. Designed for real results.
        </p>
      </section>


      {/* ================= INTRO ================= */}
      <section className="ab7-intro">
        <div className="intro-text">
          <h2>Who We Are</h2>
          <p>
            PULSE is not a casual gym. It’s a performance environment where
            structure, effort, and consistency define progress.
          </p>
          <p>
            We train individuals who want measurable strength, endurance,
            confidence, and long-term capability — without shortcuts.
          </p>
        </div>

        <div className="intro-image">
          <img
            src="https://images.pexels.com/photos/3763878/pexels-photo-3763878.jpeg"
            alt="training"
          />
        </div>
      </section>


      {/* ================= VALUES ================= */}
      <section className="ab7-values">
        <h2>Our Core Values</h2>

        <div className="values-grid">
          <div className="value-card">
            <h3>Discipline</h3>
            <p>Progress begins with structure and consistency.</p>
          </div>

          <div className="value-card">
            <h3>Performance</h3>
            <p>Training built around capability, not aesthetics.</p>
          </div>

          <div className="value-card">
            <h3>Longevity</h3>
            <p>Strength that supports decades of movement.</p>
          </div>

          <div className="value-card">
            <h3>Accountability</h3>
            <p>Coaching that corrects, guides, and challenges.</p>
          </div>
        </div>
      </section>


      {/* ================= PHILOSOPHY STRIP (NEW) ================= */}
      <section className="ab7-philosophy">
        <h2>Our Training Philosophy</h2>

        <div className="philo-grid">
          <div>
            <span>01</span>
            <h4>Foundation First</h4>
            <p>Movement quality before intensity or load.</p>
          </div>

          <div>
            <span>02</span>
            <h4>Progressive Stress</h4>
            <p>Structured overload without burnout.</p>
          </div>

          <div>
            <span>03</span>
            <h4>Recovery Matters</h4>
            <p>Rest and mobility are programmed, not optional.</p>
          </div>
        </div>
      </section>


      {/* ================= STORY ================= */}
      <section className="ab7-story">
        <div className="story-image">
          <img
            src="https://images.pexels.com/photos/1552106/pexels-photo-1552106.jpeg"
            alt="story"
          />
        </div>

        <div className="story-text">
          <h2>Why PULSE Exists</h2>
          <p>
            Most gyms sell motivation. We build habits.
          </p>
          <p>
            PULSE was created to remove noise and focus on training principles
            that actually work — intelligent progression, recovery, and intent.
          </p>
        </div>
      </section>


      {/* ================= WHO IT’S FOR (NEW) ================= */}
      <section className="ab7-audience">
        <h2>Who Trains Here</h2>

        <div className="audience-grid">
          <div className="aud-card">
            <h4>Athletes</h4>
            <p>Looking to increase output, resilience, and control.</p>
          </div>

          <div className="aud-card">
            <h4>Professionals</h4>
            <p>Balancing performance with recovery and time efficiency.</p>
          </div>

          <div className="aud-card">
            <h4>Beginners</h4>
            <p>Ready to learn proper movement from day one.</p>
          </div>

          <div className="aud-card">
            <h4>Long-Term Trainers</h4>
            <p>Focused on staying strong, mobile, and pain-free.</p>
          </div>
        </div>
      </section>


      {/* ================= STATEMENT ================= */}
      <section className="ab7-statement">
        <h2>
          TRAIN WITH <span>INTENT</span>
        </h2>
        <p>
          Every rep. Every session. Every phase.
        </p>
      </section>

    </div>
  );
};

export default About;
